import ComparisonShoppingPageActions from './csp_actions';
import ComparisonShoppingPage from './comparison_shopping_page';
import alt, { AltStoreModel } from '../../alt';
import APIComparisonShoppingPage from './api_comparison_shopping_page';

interface State {
  loaded: boolean;
  preloaded: boolean;
  response: {
    comparison_shopping_pages: APIComparisonShoppingPage[];
    featured: APIComparisonShoppingPage[];
    total_pages?: number;
    current_page?: number;
  };
}

class ComparisonShoppingPageStore extends AltStoreModel<State> implements State {
  preloaded = false;

  loaded = null;

  response = {
    comparison_shopping_pages: [],
    featured: [],
  };

  constructor() {
    super();

    this.bindActions(ComparisonShoppingPageActions);

    // When loaded is truthy when calling bindActions, Alt tries to bind to it :-(
    this.loaded = true;

    this.exportPublicMethods({
      featuredPagesWithImages: this.featuredPagesWithImages,
      pagesWithImages: this.pagesWithImages,
    });
  }

  get initialState(): State {
    return {
      preloaded: false,
      loaded: true,
      response: {
        comparison_shopping_pages: [],
        featured: [],
      },
    };
  }

  onLoaded(response) {
    this.setState({
      response,
      preloaded: false,
      loaded: true,
    });
  }

  onClear() {
    this.setState({ ...this.initialState, loaded: true });
  }

  onLoading() {
    this.setState({
      preloaded: false,
      loaded: false,
    });
  }

  onErrored() {
    this.setState({ ...this.initialState, loaded: true });
  }

  onPreloadClear() {
    this.setState({ preloaded: false });
  }

  featuredPagesWithImages() {
    return (this.getState().response.featured || [])
      .map(page => new ComparisonShoppingPage(page))
      .filter(page => page.hasGridImage());
  }

  pagesWithImages() {
    return (this.getState().response.comparison_shopping_pages || [])
      .map(page => new ComparisonShoppingPage(page))
      .filter(page => page.hasHorizontalImage());
  }
}

export default alt.createStore(ComparisonShoppingPageStore, 'ComparisonShoppingPageStore');
